"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent, CardDescription } from "@/components/ui/card";
const filmSets = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/shipping_container_trailer_set.png",
  description: "Versatile shipping container configuration designed for mobile production trailers with customizable interior layouts and equipment storage."
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/studio_interior_filming_space.png",
  description: "Spacious studio interior with flexible layout options and advanced equipment for controlled environment filming."
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/shipping_container_production_office_base.png",
  description: "Modified shipping container serving as an on-site production office and base camp with workstations, communication systems, and crew coordination facilities."
}, {
  id: 4,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/outdoor_natural_location_shoot.png",
  description: "Scenic outdoor natural location featuring versatile terrain and beautiful lighting for authentic storytelling."
}, {
  id: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/industrial_warehouse_set_design.png",
  description: "Industrial warehouse space transformed into a creative set with high ceilings and customizable design elements."
}, {
  id: 6,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/modern_office_filming_environment.png",
  description: "Contemporary office environment ideal for corporate videos and brand content with sleek, professional aesthetics."
}, {
  id: 7,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/shipping_container_camera_equipment_storage.png",
  description: "Secure shipping container unit equipped for professional camera and lighting equipment storage with climate control and organized shelving systems."
}];
export default function FilmSetGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section ref={ref} className="py-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Our Film Sets
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our diverse collection of professional filming locations designed to bring your creative vision to life.
          </p>
        </div>

        <div className={`transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {filmSets.map((set, i) => <CarouselItem key={set.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <Card className="h-full shadow-medium hover:shadow-strong transition-shadow duration-300 border border-border">
                    <img src={set.image} alt={set.description} className="w-full h-64 object-cover rounded-t-xl" />
                    <CardContent className="pt-6">
                      <CardDescription className="text-foreground text-base leading-relaxed">
                        {set.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="left-0 -translate-x-12 hover:bg-primary-dark hover:text-foreground-primary" />
              <CarouselNext className="right-0 translate-x-12 hover:bg-primary-dark hover:text-foreground-primary" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}